import styled from "styled-components";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { AdCard, AdCardFooterLoading, ImgContainer } from "./StyledComponents";

const FlexSpaceBetween = styled(FlexRow)`
    width: 100%;
    justify-content: space-between;
    gap: 12px;
`;

const PixelPlaceholderLoaderWithBorderRadius = styled(PixelPlaceholderLoader)`
    border-radius: 6px;
`;

const TEXT_LOADING_HEIGHT = 16;
const TEXT_LOADING_WIDTH = 82;

interface IAdIntelligenceAdCardLoadingProps {
    size: "sm" | "md" | "lg";
}

const sizeToWidth: Record<IAdIntelligenceAdCardLoadingProps["size"], number> = {
    sm: 90,
    md: 282,
    lg: 632,
};

const AdIntelligenceAdCardLoading = ({ size }: IAdIntelligenceAdCardLoadingProps) => {
    return (
        <AdCard>
            <ImgContainer
                $height={sizeToWidth[size]}
                $isLoading={true}
            >
                <PixelPlaceholderLoader
                    height={sizeToWidth[size]}
                    width="100%"
                />
            </ImgContainer>
            <AdCardFooterLoading>
                <FlexSpaceBetween>
                    <PixelPlaceholderLoaderWithBorderRadius
                        height={TEXT_LOADING_HEIGHT}
                        width={TEXT_LOADING_WIDTH}
                    />
                    <PixelPlaceholderLoaderWithBorderRadius
                        height={TEXT_LOADING_HEIGHT}
                        width={TEXT_LOADING_WIDTH}
                    />
                    <PixelPlaceholderLoaderWithBorderRadius
                        height={TEXT_LOADING_HEIGHT}
                        width={TEXT_LOADING_WIDTH}
                    />
                    <PixelPlaceholderLoaderWithBorderRadius
                        height={TEXT_LOADING_HEIGHT}
                        width={TEXT_LOADING_HEIGHT}
                    />
                </FlexSpaceBetween>
            </AdCardFooterLoading>
        </AdCard>
    );
};

export const getLoadingCards = () => {
    const cardSizes: IAdIntelligenceAdCardLoadingProps["size"][] = ["sm", "lg", "md", "lg", "md", "md", "sm"];
    return Array.from({ length: cardSizes.length }, (_, index) => (
        <AdIntelligenceAdCardLoading
            key={index}
            size={cardSizes[index]}
        />
    ));
};
